export const profileLinks = {
    profile: () => '/profile',
    apiTokens: () => '/tokens',
    recoveryRequest: () => '/recovery/request',
    recoveryNew: () => '/recovery/renew'
};
